import { render, staticRenderFns } from "./examineTabs.vue?vue&type=template&id=a49ac75c&scoped=true&"
import script from "./examineTabs.vue?vue&type=script&lang=js&"
export * from "./examineTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49ac75c",
  null
  
)

export default component.exports